import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// ── English namespaces ──────────────────────────────────────────────
import enCommon from '../locales/en/common.json';
import enHome from '../locales/en/home.json';
import enAbout from '../locales/en/about.json';
import enContact from '../locales/en/contact.json';
import enServices from '../locales/en/services.json';
import enServiceDetails from '../locales/en/serviceDetails.json';
import enAreas from '../locales/en/areas.json';
import enBlog from '../locales/en/blog.json';
import enLocallaw from '../locales/en/locallaw.json';
import enFisp from '../locales/en/fisp.json';
import enSeo from '../locales/en/seo.json';
import enResources from '../locales/en/resources.json';

// ── Spanish namespaces ──────────────────────────────────────────────
import esCommon from '../locales/es/common.json';
import esHome from '../locales/es/home.json';
import esAbout from '../locales/es/about.json';
import esContact from '../locales/es/contact.json';
import esServices from '../locales/es/services.json';
import esServiceDetails from '../locales/es/serviceDetails.json';
import esAreas from '../locales/es/areas.json';
import esBlog from '../locales/es/blog.json';
import esLocallaw from '../locales/es/locallaw.json';
import esFisp from '../locales/es/fisp.json';
import esSeo from '../locales/es/seo.json';
import esResources from '../locales/es/resources.json';

const resources = {
  en: {
    common: enCommon,
    home: enHome,
    about: enAbout,
    contact: enContact,
    services: enServices,
    serviceDetails: enServiceDetails,
    areas: enAreas,
    blog: enBlog,
    locallaw: enLocallaw,
    fisp: enFisp,
    seo: enSeo,
    resources: enResources,
  },
  es: {
    common: esCommon,
    home: esHome,
    about: esAbout,
    contact: esContact,
    services: esServices,
    serviceDetails: esServiceDetails,
    areas: esAreas,
    blog: esBlog,
    locallaw: esLocallaw,
    fisp: esFisp,
    seo: esSeo,
    resources: esResources,
  },
};

// Custom language detector that reads the first URL path segment
const pathLanguageDetector = {
  name: 'pathDetector',
  lookup(): string {
    const firstSegment = window.location.pathname.split('/').filter(Boolean)[0];
    return firstSegment === 'es' ? 'es' : 'en';
  },
  cacheUserLanguage(): void {
    // no-op: URL is the source of truth
  },
};

const languageDetectorInstance = new LanguageDetector();
languageDetectorInstance.addDetector(pathLanguageDetector);

i18n
  .use(languageDetectorInstance)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    ns: [
      'common',
      'home',
      'about',
      'contact',
      'services',
      'serviceDetails',
      'areas',
      'blog',
      'locallaw',
      'fisp',
      'seo',
      'resources',
    ],
    defaultNS: 'common',
    detection: {
      order: ['pathDetector'],
      caches: [],
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;
